<template>
  <div class="home">
  <div class="md-layout md-gutter">
    <div class="md-layout-item md-size-100">
      <md-field>
        <label for="last-name">Session Id</label>
        <md-input name="session-id" id="session-id" :value="sessionId" @input="updateSession" />
      </md-field>
    </div>
    <div class="md-layout-item md-size-100">
      <md-button to="/card">Подключиться</md-button>
    </div>
  </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Home',
  computed: {
    ...mapState([
      'sessionId'
    ])
  },
  components: {

  },
  methods: {
    updateSession(sessionId) {
      this.$store.dispatch('updateSession', sessionId)
    }
  }
}
</script>

<style lang="scss">
  .md-layout {
    
  }

</style>
